<template>
    <div class="box1">
        <div class="main">
            <div class="title">
                <div class="text">旅行社基本信息</div>
            </div>
            <div class="content">
                <div class="row">
                    <div class="left">旅行社名称</div>
                    <div class="right">昆明乐水国际旅行社有限公司</div>
                </div>
                <div class="row">
                    <div class="left">旅行社英文名</div>
                    <div class="right">kshf fksahf kjsfhs</div>
                </div>
                <div class="row">
                    <div class="left">旅行社等级</div>
                    <div class="right">未评级</div>
                </div>
                <div class="row">
                    <div class="left">等级认定时间</div>
                    <div class="right">2013</div>
                </div>
                <div class="row">
                    <div class="left">统一社会信用代码</div>
                    <div class="right">765487398012347</div>
                </div>
                <div class="row">
                    <div class="left">注册资金（万元）</div>
                    <div class="right">533</div>
                </div>
                <div class="row">
                    <div class="left">企业注册时间</div>
                    <div class="right">2013-10-25</div>
                </div>
                <div class="row">
                    <div class="left">企业类型</div>
                    <div class="right">有限责任企业</div>
                </div>
                <div class="row">
                    <div class="left">业务经营许可证号</div>
                    <div class="right">L-YN-00701</div>
                </div>
                <div class="row">
                    <div class="left">法定代表人</div>
                    <div class="right">杨俊</div>
                </div>
                <div class="row">
                    <div class="left">法定代表人手机号</div>
                    <div class="right">18800006666</div>
                </div>
                <div class="row">
                    <div class="left">总经理</div>
                    <div class="right">无</div>
                </div>
                <div class="row">
                    <div class="left">经营状况</div>
                    <div class="right">营业中</div>
                </div>
                <div class="row">
                    <div class="left">企业开户银行</div>
                    <div class="right">上海浦东发展银行股份有限公司昆明关上支行</div>
                </div>
                <div class="row">
                    <div class="left">企业开户名</div>
                    <div class="right">无</div>
                </div>
                <div class="row">
                    <div class="left">开户银行账号</div>
                    <div class="right">27428462780023784</div>
                </div>
                <div class="row">
                    <div class="left">保证金存缴银行</div>
                    <div class="right">上海浦东发展银行</div>
                </div>
                <div class="row">
                    <div class="left">保证金存缴金额（元）</div>
                    <div class="right">20.0</div>
                </div>
                <div class="row">
                    <div class="left">保证金存缴金额（元）</div>
                    <div class="right">20.0</div>
                </div>
                <div class="row">
                    <div class="left">州市</div>
                    <div class="right"></div>
                </div>
                <div class="row">
                    <div class="left">通讯地址</div>
                    <div class="right">昆明市官渡区吴井路吴井新苑1单元501</div>
                </div>
                <div class="row">
                    <div class="left">邮政编码</div>
                    <div class="right">650011</div>
                </div>
                <div class="row">
                    <div class="left">从业人员</div>
                    <div class="right">6</div>
                </div>
                <div class="row">
                    <div class="left">联系电话</div>
                    <div class="right">0871-88886666</div>
                </div>
                <div class="row">
                    <div class="left">传真</div>
                    <div class="right"></div>
                </div>
                <div class="row">
                    <div class="left">服务质量监督及投诉负责人</div>
                    <div class="right">刘俊</div>
                </div>
                <div class="row">
                    <div class="left">服务质量监督及投诉电话</div>
                    <div class="right">0871-88886666</div>
                </div>
                <div class="row">
                    <div class="left">企业网址</div>
                    <div class="right"></div>
                </div>
                <div class="row">
                    <div class="left">企业电子邮箱</div>
                    <div class="right"></div>
                </div>
                <div class="row">
                    <div class="left">企业概况及经营特色</div>
                    <div class="right"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>
<style lang="less" scoped>
    .box1 {
        width: 100%;
        padding: 14px;
        background-color: #f4f3f3;
        box-sizing: border-box;
        .main {
            width: 100%;
            background-color: #fff;
            .title {
                width: 100%;
                padding: 5px 0;
                box-sizing: border-box;
                border-bottom: 1px solid #efeded;
                .text {
                    font-size: 16px;
                    font-weight: 500;
                    border-left: 5px solid blue;
                    padding-left: 10px;
                }
            }
            .content {
                width: 100%;
                padding: 20px;
                box-sizing: border-box;
                .row {
                    font-size: 14px;
                    min-height: 20px;
                    max-height: 40px;
                    line-height: 20px;
                    margin-top: 20px;
                    display: flex;
                    .left {
                        float: left;
                        width: 48%;
                        text-align: left;
                    }
                    .right {
                        float: left;
                        width: 50%;
                        margin-left: 10px;
                    }
                }
            }
        }
    }
</style>
